var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel-judge"},[_c('judge-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }